import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Row,
  Col,
} from 'reactstrap';
import { connect } from 'react-redux';
import Link from 'next/link';
import IconX from 'flaivy-react/components/icons/IconX';
import StyledButton from 'flaivy-react/components/StyledButton';
import Router from 'next/router';
import { logout as _logout } from 'flaivy-react/actions/auth.actions';

function UserOffCanvas({ toggle, isOpen, logout, sessionUser, shopConfig }) {
  const {
    firstName,
    lastName,
    customerSubUnit = {},
    supplierCustomer = {},
  } = sessionUser;

  const uppercaseFirstname = sessionUser
    ? firstName[0].toUpperCase() + firstName.substring(1)
    : null;
  const uppercaseLastname = sessionUser
    ? lastName[0].toUpperCase() + lastName.substring(1)
    : null;

  const logOutUser = async () => {
    await logout();

    // TODO remove window.location in auth action.
    Router.push('/');
  };

  return (
    <Offcanvas
      id="cartModal"
      className="top-right"
      role="dialog"
      direction="end"
      toggle={toggle}
      isOpen={isOpen}
    >
      <OffcanvasHeader className="justify-content-end p-1">
        <Button
          onClick={toggle}
          aria-label="Close"
          className="close-rotate"
          color="none"
        >
          <IconX height="20" />
        </Button>
      </OffcanvasHeader>
      <OffcanvasBody>
        <Col className="p-2">
          <Row className="justify-content-center pb-3">
            <h5>{`${uppercaseFirstname} ${uppercaseLastname}`}</h5>
          </Row>
          <Row className="justify-content-center">
            <h6 className="text-md text-gray500">
              {customerSubUnit.name || supplierCustomer.name}
            </h6>
          </Row>
          <Row className="justify-content-center">
            <p className="text-sm text-muted">
              Kundnummer:{' '}
              {customerSubUnit.customerNumber ||
                supplierCustomer.customerNumber}
            </p>
          </Row>
          <Row className="justify-content-center mt-3">
            <Col sm={12}>
              <Link href="/app/orders" className="text-decoration-none">
                <StyledButton
                  onClick={toggle}
                  block
                  outline
                  color="dark"
                  className="mt-3"
                >
                  orderhistorik
                </StyledButton>
              </Link>
            </Col>
            <Col sm={12}>
              <Link
                href="/app/change-addresses"
                className="text-decoration-none"
              >
                <StyledButton
                  onClick={toggle}
                  block
                  outline
                  color="dark"
                  className="mt-3"
                >
                  företagsuppgifter
                </StyledButton>
              </Link>
            </Col>
            {shopConfig.isSellingAlcohol && (
              <Col sm={12}>
                <Link
                  href="/app/restaurant-report"
                  className="text-decoration-none"
                >
                  <StyledButton
                    onClick={toggle}
                    block
                    outline
                    color="dark"
                    className="mt-3"
                  >
                    Volymrapport
                  </StyledButton>
                </Link>
              </Col>
            )}
            <Col sm={12}>
              <Link
                href="/app/change-password"
                className="text-decoration-none"
              >
                <StyledButton
                  onClick={toggle}
                  block
                  outline
                  color="dark"
                  className="mt-3"
                >
                  mina uppgifter
                </StyledButton>
              </Link>
            </Col>
            <Col sm={12}>
              <StyledButton
                onClick={() => {
                  logOutUser();
                }}
                block
                color="dark"
                className="mt-3"
              >
                logga ut
              </StyledButton>
            </Col>
          </Row>
        </Col>
      </OffcanvasBody>
    </Offcanvas>
  );
}

const mapStateToProps = ({ authentication, shopConfig }) => ({
  sessionUser: authentication.sessionUser,
  shopConfig,
});

const mapDispatchToProps = {
  logout: _logout,
};

UserOffCanvas.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  sessionUser: PropTypes.object.isRequired,
  shopConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserOffCanvas);
